<template>
  <div class="appcontainer">
  
    <div class="appcontainer__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <div class="appcontainer__tool">
      
    </div>

    <div class="appcontainer__content">        
        <div class="sortable_container">
          <div class="sortable_info">
              <el-alert
                title="可进行拖拽调整位置"
                type="success">
              </el-alert>
          </div>

          <div class="sortable_dragable" v-loading = "loading">
              <draggable
                v-model="datas"
                group="people"
                @start="onDragStart"
                @end="onDragEnd"
                :move="onDragItemMoved"
                v-bind="dragOptions"
              >
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(element,index) in datas" :key="element.id" class="sortable_item list-group-item">
                      <div class="sortable_item__index font_base"> {{index + 1}}</div>
                      <div class="sortable_item__title font_base"> {{element.title}}</div>
                    </div>
                  </transition-group>
              </draggable>
          </div>


        </div>      
    </div>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { locationApi, exchangeApi } from "@/api/core/container/sortablecontainer";
// import draggable from "vuedraggable";

export default {
  name: "SortableContainer",
  
  mixins: [BaseVue],
  
  props: {
    // api 默认地址
    serverUrl: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      drag: true,
      datas: [],
      loading: false,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    };
  },
  
  methods: {
    init() {
      this.loading = true;
      locationApi(this.serverUrl)
        .then(response => {
          this.datas = response;
          // console.log("locationApi", response);
        })
        .catch(error => {
          // 错误处理
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 事件处理
    onDragItemMoved(evt) {
      this.drag = true;
      this.loading = true;

      let start = evt.draggedContext.index;
      let startEle = evt.draggedContext.element;
      let end = evt.relatedContext.index;
      let endEle = evt.relatedContext.element;
      
      console.log("on drag item moved", "start : " + start + " - end : " + end);
      this.loading = false;
      
      return;
    },
    
    onDragStart(evt) {
      console.log("onDragStart", evt);
    },
    
    onDragEnd(evt) {
      this.loading = true;

      let oldIndex = evt.oldIndex;
      let newIndex = evt.newIndex;

      console.log("onDragEnd", evt);    
      console.log("onDragEnd", oldIndex + " -> " + newIndex);
      
      exchangeApi(this.serverUrl, oldIndex, newIndex)
        .then(response => {
          this.$message.success("操作成功");
        })
        .catch(error => {
          this.$message.error("操作错误： " + error);
          console.log("error", error);
          this.init();        
        })
        .finally(() => {
          this.drag = false;
          this.loading = false;
        });
    },
    
    sort() {
      // 升序 a-b < 0   a将排到b的前面，按照a的大小来排序的
      this.datas = this.datas.sort((a, b) => a.sort - b.sort);
    }
  },
  
  // 生命周期钩子
  beforeCreate() {
    // 组件创建前的逻辑
  },
  
  created() {
    // 组件创建后的逻辑
  },
  
  beforeMount() {
    this.init();
  },
  
  mounted() {
    // 组件挂载后的逻辑
  },

};
</script>

<style scoped lang="scss">
// ref sortablecontainer.scss

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>